// Site-wide design switches. Change a value here to swap the look everywhere;
// set them back to revert. Both can also be previewed live on /lab.

export const DESIGN = {
  // Dark-mode background: 'stillNebula' | 'milkyWay' | 'starTrails' | 'aurora'
  //   | 'pixelHorizon' | 'constellations'
  sky: 'pixelHorizon',
  // Moon music player: 'ipod' | 'terminal'
  player: 'ipod',
  // Cooking page layout: 'grid' | 'masonry' | 'bento' | 'collage' | 'contact'
  cooking: 'collage',
};
